import React, { useState, useContext } from "react";
import Form from 'react-bootstrap/Form';
import { TbListCheck } from "react-icons/tb";
import { BookingContext } from "./BookingContext";
import { LoginContext } from "../../LoginContext";
import { Modal } from "react-bootstrap";
import { usePaymentInputs } from 'react-payment-inputs';
import { getpaymentMethod } from "../../Api/dashboardApi";
import { createPaymentMethod } from "../../Api/dashboardApi";
import { NotificationContainer, NotificationManager } from 'react-notifications';






const Step4 = props => {

    const [usertype, setUsertype, chooseservice, setChooseservice, choosesubservice, setChoosesubservice, chooseaddon, setChooseaddon, choosetechnician, setChoosetechnician, choosedate, setChoosedate, choosetime, setChoosetime, userDetails, setUserDetails, paymentDetails, setPaymentDetails, Totalpayment, setTotalpayment, totalDuration, setTotalDuration, appointmentNotes, setAppointmentNotes, servicename, setServicename, endchoosetime, setEndchoosetime, confirmpassword, setConfirmpassword] = useContext(BookingContext);
    const { LoggedInData, login, logout } = useContext(LoginContext);

    const { getExpiryDateProps } = usePaymentInputs();

    const [cardNumber, setCardNumber] = useState('');
    const [cardExpDate, setCardExpDate] = useState('');
    const [cardCVV, setCardCVV] = useState('');
    const [fullName, setFullName] = useState('');
    const [addCardValidate, setAddCardValidate] = useState(false)

    const [addCard, setAddCard] = useState(false);

    const [selectedCard, setSelectedCard] = useState('');
    const [paymentMethod, setPaymentMethod] = useState([]);
    const [cardExpYearerror, setCardExpYearerror] = useState(false);

    const [cardNumbererror, setCardNumbererror] = useState(false);
    const [cardCVVerror, setCardCVVerror] = useState(false);
    const [cardExpDateerror, setCardExpDateerror] = useState(false);
    const [fullNamerror, setFullNamerror] = useState(false);

    const getpaymentCards = () => {
        const LoggedInData = JSON.parse(localStorage.getItem('userdata'));
        const formData = new FormData();

        if (LoggedInData && LoggedInData.id) {
            formData.append('customer_id', LoggedInData.customer_id);
        }
        getpaymentMethod(formData).then((res) => {
            if (res.code == 200) {
                const paymentMethod = res.data.data;
                setPaymentMethod(paymentMethod);
                if (paymentMethod && paymentMethod.length != 0 && !selectedCard) {
                    setSelectedCard(`cardOption0`);
                    setPaymentDetails(paymentMethod[0]);
                }
            }
        }).catch((error) => {
            console.log(error);
        });
    }



    React.useEffect(() => {
        getpaymentCards();
    }, []);


    React.useEffect(() => {
        getpaymentCards();
    }, [LoggedInData]);

    // const handleAddCard = () => {

    //     //check if name like sanjay kumar
    //     const name = fullName.split(' ');
    //     if (name.length < 2) {
    //         alert("Please enter full name");
    //         return;
    //     }

    //     const expDateParts = cardExpDate.split('/');

    //     const expMonth = parseInt(expDateParts[0]);
    //     const expYear = parseInt(expDateParts[1]);

    //     const currentMonth = new Date().getMonth() + 1; // Month is 0-indexed, so add 1
    //     const currentYear = new Date().getFullYear() % 100; // Get the last two digits of the current year

    //     if (expYear < currentYear || (expYear === currentYear && expMonth < currentMonth)) {
    //         // alert("Card expiration date should be in the future.");
    //         setCardExpYearerror(true);
    //         return;
    //     }

    //     if (cardNumber == '' || cardNumber.length != 16 || fullName == '' || cardCVV == '' || cardCVV.length != 3 || cardExpDate == '') {
    //         setAddCardValidate(true)
    //     } else {
    //         const formData = new FormData();
    //         if (LoggedInData && LoggedInData.id) {
    //             formData.append('customer_id', LoggedInData.customer_id);
    //         }
    //         formData.append("card_number", cardNumber);
    //         formData.append("person_name", fullName);
    //         formData.append("card_cvv", cardCVV);
    //         formData.append("card_exp", cardExpDate);

    //         createPaymentMethod(formData).then((res) => {
    //             if (res.code === 200) {
    //                 alert("Card Added Successfully");
    //                 getpaymentCards();
    //                 setAddCard(false);
    //             }
    //             else {
    //                 alert("Something went wrong");
    //             }
    //         }).catch((err) => {
    //             console.log("err", err);
    //         });
    //     }
    // }

    const [addpaymentloader, setAddpaymentloader] = useState(false);

    const digitsOnly = (s = "") => String(s).replace(/\D/g, "");


    // Expiry date parser (MM/YY or MMYY)
    const parseAndValidateExp = (raw) => {
        const digits = digitsOnly(raw);
        if (digits.length !== 4) return null;

        const month = Number(digits.slice(0, 2));
        const yearYY = Number(digits.slice(2, 4));

        if (!(month >= 1 && month <= 12)) return null;

        const now = new Date();
        const currMonth = now.getMonth() + 1;
        const currYearYY = now.getFullYear() % 100;

        const isFuture = yearYY > currYearYY || (yearYY === currYearYY && month >= currMonth);
        if (!isFuture) return null;

        return {
            month,
            yearYY,
            mmyy: `${String(month).padStart(2, "0")}${String(yearYY).padStart(2, "0")}`
        };
    };

    const handleAddCard = async () => {
        try {
            setAddpaymentloader(true);

            // --- Full Name ---
            const trimmedName = String(fullName || "").trim();
            if (!trimmedName || trimmedName.split(/\s+/).length < 2) {
                setFullNamerror(true);
                return;
            } else {
                setFullNamerror(false);
            }

            // --- Card Number (11–16 digits) ---
            const num = digitsOnly(cardNumber);
            if (num.length < 11 || num.length > 16) {
                setCardNumbererror(true);
                return;
            } else {
                setCardNumbererror(false);
            }

            // --- CVV (3 or 4 digits) ---
            const cvv = digitsOnly(cardCVV);
            if (cvv.length < 3 || cvv.length > 4) {
                setCardCVVerror(true);
                return;
            } else {
                setCardCVVerror(false);
            }

            // --- Expiry Date ---
            if (!cardExpDate || cardExpDate.trim() === "") {
                setCardExpDateerror(true);
                setCardExpYearerror(false); // Clear the other error
                return;
            }

            const exp = parseAndValidateExp(cardExpDate);
            if (!exp) {
                // Check if it's a format issue or expiry issue
                const digits = digitsOnly(cardExpDate);
                if (digits.length !== 4) {
                    setCardExpDateerror(true);
                    setCardExpYearerror(false);
                } else {
                    // It's likely an expiry date issue (past date or invalid month)
                    setCardExpDateerror(false);
                    setCardExpYearerror(true);
                }
                return;
            } else {
                setCardExpDateerror(false);
                setCardExpYearerror(false);
            }

            // --- Form Data ---
            const formData = new FormData();
            if (LoggedInData && (LoggedInData.customer_id || LoggedInData.id)) {
                formData.append("customer_id", LoggedInData.customer_id ?? LoggedInData.id);
            }
            formData.append("card_number", num);
            formData.append("person_name", trimmedName);
            formData.append("card_cvv", cvv);
            formData.append("card_exp", exp.mmyy); // mmyy format

            const res = await createPaymentMethod(formData);

            if (res?.code === 200) {
                if (res?.data?.status === "1") {
                    NotificationManager.success("Card Added Successfully");
                    await getpaymentCards?.();
                    setAddCard(false);
                    setCardNumber("");
                    setCardCVV("");
                    setCardExpDate("");
                } else {
                    NotificationManager.error(res?.data?.message || "Unable to add card");
                }
            } else {
                NotificationManager.error("Something went wrong");
            }
        } catch (err) {
            console.error("err", err);
            NotificationManager.error("Unexpected error");
        } finally {
            setAddpaymentloader(false);
        }
    };


    React.useEffect(() => {
        if (LoggedInData != null) {
            setFullName(LoggedInData.first_name + " " + LoggedInData.last_name);
        }
    }, [LoggedInData]);

    React.useEffect(() => {
        if (LoggedInData == null) {
            setPaymentMethod([]);
        }
    }, [LoggedInData]);

    const onCardNumberChange = (event) => {
        let { value, name } = event.target;
        let cardNumber = value;
        value = value.replace(/\D/g, '');
        if (/^3[47]\d{0,13}$/.test(value)) {
            cardNumber = value
                .replace(/(\d{4})/, '$1 ')
                .replace(/(\d{4}) (\d{6})/, '$1 $2 ');
        } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
            // diner's club, 14 digits
            cardNumber = value
                .replace(/(\d{4})/, '$1 ')
                .replace(/(\d{4}) (\d{6})/, '$1 $2 ');
        } else if (/^\d{0,16}$/.test(value)) {
            // regular cc number, 16 digits
            cardNumber = value
                .replace(/(\d{4})/, '$1 ')
                .replace(/(\d{4}) (\d{4})/, '$1 $2 ')
                .replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ');
        }

        setCardNumber(cardNumber.trimRight());
    };

    if (props.currentStep !== 4) {
        return null;
    }

    return (
        <>
            <Modal show={addCard} onHide={() => setAddCard(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>New Card Details</Modal.Title>
                </Modal.Header>
                <Modal.Body className='custum-modal-body'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <Form.Group className="mb-4" controlId="validationCustom01">
                                <Form.Label className='custom-lable'>Card Number</Form.Label>
                                <Form.Control
                                    required
                                    type="tel"
                                    name="cardNumber"
                                    className="custom-input"
                                    autoComplete="off"
                                    onChange={onCardNumberChange}
                                    onBlur={() => {
                                        if (cardNumber.length < 19) {
                                            setCardNumbererror(true);
                                        } else {
                                            setCardNumbererror(false);
                                        }
                                    }}
                                    maxLength="19"
                                    value={cardNumber} />
                                {cardNumbererror == true ? <p style={{ color: 'red' }}>card number is required</p> : null}
                            </Form.Group>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            {/* <Form.Group className="mb-4" controlId="validationCustom01">
                                <Form.Label className='custom-lable'>Exp. Date</Form.Label>
                                <Form.Control required type="Text" placeholder="MM/YY" className='custom-input'
                                    value={cardExpDate}
                                    {...getExpiryDateProps({ onChange: (e) => setCardExpDate(e.target.value) })} />
                                {cardExpDateerror == true ? <p style={{ color: 'red' }}>please enter card exipry date</p> : ''}
                                {cardExpYearerror == true ? <p style={{ color: 'red' }}>Card expiration date should be in the future.</p> : ''}
                            </Form.Group> */}
                            <Form.Group className="mb-4" controlId="validationCustom01">
                                <Form.Label className='custom-lable'>Exp. Date</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="MM/YY"
                                    className='custom-input'
                                    value={cardExpDate}
                                    {...getExpiryDateProps({
                                        onChange: (e) => setCardExpDate(e.target.value)
                                    })}
                                    onBlur={() => {
                                        if (cardExpDate.trim() === "") {
                                            setCardExpDateerror(true);
                                            setCardExpYearerror(false); // Clear the other error
                                        } else {
                                            const exp = parseAndValidateExp(cardExpDate);
                                            if (!exp) {
                                                const digits = digitsOnly(cardExpDate);
                                                if (digits.length !== 4) {
                                                    setCardExpDateerror(true);
                                                    setCardExpYearerror(false);
                                                } else {
                                                    setCardExpDateerror(false);
                                                    setCardExpYearerror(true);
                                                }
                                            } else {
                                                setCardExpDateerror(false);
                                                setCardExpYearerror(false);
                                            }
                                        }
                                    }
                                    }
                                />
                                {cardExpDateerror && (
                                    <p style={{ color: 'red' }}>Please enter a valid card expiry date (MM/YY)</p>
                                )}
                                {cardExpYearerror && (
                                    <p style={{ color: 'red' }}>Card expiration date should be in the future.</p>
                                )}
                            </Form.Group>
                        </div>
                        <div className='col-md-6'>
                            <Form.Group className="mb-4" controlId="validationCustom01">
                                <Form.Label className='custom-lable'>CVV</Form.Label>
                                <Form.Control required type="number" placeholder="CVV" className='custom-input'
                                    value={cardCVV}
                                    // onInput={
                                    //     (e) => {
                                    //         e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4);
                                    //         setCardCVVerror(false);
                                    //     }
                                    // }
                                    onInput={(e) => {
                                        let value = e.target.value;
                                        // Remove any non-digit characters
                                        value = value.replace(/\D/g, '');
                                        // Limit to 4 digits
                                        value = value.slice(0, 4);
                                        // Set the cleaned value
                                        e.target.value = value;
                                        setCardCVVerror(false);
                                    }}
                                    onChange={(e) => setCardCVV(e.target.value)} />
                                {cardCVVerror == true ? <p style={{ color: 'red' }}>please enter cvv</p> : ''}
                                {/* {cardCVV.length != 4 ? <p style={{ color: 'red' }}>cvv must have 4 digits</p> : ''} */}
                            </Form.Group>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <Form.Group className="mb-4" controlId="validationCustom01">
                                <Form.Label className='custom-lable'>Full Name</Form.Label>
                                <Form.Control required type="text" placeholder="Full Name" className='custom-input'
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)} />
                                {fullNamerror == true ? <p style={{ color: 'red' }}>please enter full name</p> : ''}
                            </Form.Group>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='modal-btn'>
                            {
                                addpaymentloader ? (<button href="#" className='btn Active-bttn' disabled>Saving...</button>) : (<button href="#" className='btn Active-bttn' type="submit" onClick={handleAddCard} >Save</button>)
                            }

                            <button href="#" className='btn Cancel-bttn' onClick={() => { setAddCard(false) }}>Cancel</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <div className="booking-form-box">
                <div className="row">
                    <div className="col-md-12">
                        <div className="step-count d-flex align-items-center justify-content-between" >
                            <div className="step-count-inner">
                                <div className="Step-icon">
                                    <span><TbListCheck /></span>
                                </div>
                                <div className="step-count-inner-title">
                                    Credit Card Details
                                </div>
                            </div>
                            <div className="add-card-button">
                                <button type="button" className="wizard-btn btn btn-primary" onClick={() => setAddCard(true)}>Add Card</button>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 booking-30">
                        {/* <div className="booking-acount-detail-form" style={{ display: usertype === 1 ? 'block' : 'none' }}> */}
                        <div className="booking-acount-detail-form">
                            {
                                Array.isArray(paymentMethod) && paymentMethod.length != 0 && paymentMethod.map((item, index) => {
                                    const cardOptionId = `cardOption${index}`;
                                    const isFirstCard = index === 0;
                                    const isChecked = selectedCard === cardOptionId || (isFirstCard && !selectedCard);
                                    return (
                                        <div class="form-check mb-3">
                                            <div className="d-flex align-items-center">
                                                <input
                                                    className="form-check-input me-3"
                                                    type="radio"
                                                    name="cardOption"
                                                    id={`cardOption${index}`}
                                                    value={`cardOption${index}`}
                                                    checked={isChecked}
                                                    defaultChecked={index === 0}
                                                    onChange={
                                                        (e) => {
                                                            setAddCard(false);
                                                            setSelectedCard(e.target.value);
                                                            setPaymentDetails(item);
                                                        }
                                                    }
                                                />
                                                {/* <input class="form-check-input me-3" type="radio" name="flexRadioDefault" id="flexRadioDefault1" /> */}
                                                <label class="form-check-label payment-card-details" for="flexRadioDefault1">
                                                    <div className="card payment-card-details">
                                                        <div className="card-body">
                                                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                                                                <div>
                                                                    <div className="card-title h5">****-****-****-{
                                                                        item.card_last_four || " "
                                                                    }</div>
                                                                    <p className="card-text">{
                                                                        item.nickname || " "
                                                                    }</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>

                                    );
                                })
                            }


                            {/* <div class="form-check mb-3">
                                <div className="d-flex align-items-center">
                                    <input
                                        className="form-check-input me-3"
                                        type="radio"
                                        name="cardOption"
                                        id="cardOption2"
                                        value="cardOption2"
                                        checked={selectedCard === 'cardOption2'}
                                        onChange={
                                            (e) => {
                                                setAddCard(false);
                                                setSelectedCard(e.target.value);
                                            }
                                        }
                                    />
                                    <label class="form-check-label payment-card-details" for="flexRadioDefault3">
                                        <div className="card payment-card-details">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center justify-content-between flex-wrap">
                                                    <div>
                                                        <div className="card-title h5">****-****-****-1234</div>
                                                        <p className="card-text">Card Name</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <NotificationContainer />
        </>
    );
};

export default Step4;
